import React, { useEffect, useState } from "react"
import { globalHistory } from "@reach/router"

// Plugins
import scrollTo from "gatsby-plugin-smoothscroll"

// Components
import Layout from "../components/layout/layout"
import Hero from "../components/hero/hero"
import WhyPedro from "../components/why-pedro/component"
import BlueZone from "../components/blue-zone/component"
import GrayZone from "../components/gray-zone/component"
import HomePlans from "../components/home-plans/component"
import Comments from "../components/comments/component"
import Steps from "../components/steps/component"
import SEO from "../components/seo"
import VideoZone from "../components/video-zone/video"

// Apollo
import { useQuery, gql } from "@apollo/client"

const IndexPage = () => {
  const [isAwaken, setAwakening] = useState(false)
  const PING = gql`
    query awakeServer {
      ping
    }
  `
  const { data } = useQuery(PING, { skip: !!isAwaken })
  useEffect(() => {
    if (
      globalHistory.location &&
      globalHistory.location.state &&
      globalHistory.location.state.scroll
    ) {
      scrollTo(`#${globalHistory.location.state.scroll}`)
      globalHistory.location.state = {}
    }
    if (data) {
      setAwakening(true)
    }
  }, [data])
  return (
    <Layout>
      <SEO title="Home" />
      <Hero />
      <WhyPedro />
      <VideoZone />
      <GrayZone />
      <Steps />
      <BlueZone />
      <HomePlans />
      <Comments />
    </Layout>
  )
}

export default IndexPage
